const validationFileInitial = {
    required: false,
    type: false,
    size: false
}

const regexText = /^([a-zA-Z ]+)$/
const regexTime = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/
const MAX_FILE_SIZE = 3 * 1024 * 1024;

const DAYS = [
    'Lunes',
    'Martes',
    'Miercoles',
    'Jueves',
    'Viernes',
    'Sabado',
    'Domingo',
];

const validateIsWorkingDay = (value?: string | Date) => {
    if (!value) return true;
    const date = new Date(value);
    if(isNaN(date.getTime())) return false;
    const day = date.getDay();

    return day !== 0;
}

const validateIsWorkingHours = (value?: string | Date) => {
    if (!value) return true;
    const date = new Date(value);
    if(isNaN(date.getTime())) return false;

    const hours = date.getHours();
    const minutes = date.getMinutes();

    if(hours < 8 || hours > 18) return false;
    if(hours === 18 && minutes > 0) return false;

    return true;
}

const validateIsDateInPast = (value?: string | Date) => {
    if (!value) return true;
    const date = new Date(value);
    if(isNaN(date.getTime())) return false;

    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);

    return date.getTime() >= tomorrow.getTime();
}

const defaultInterviewDateTime = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(8, 0, 0, 0);
    return tomorrow;
}

const handleShouldDisableDate = (date: Date) => {
    const day = date.getDay();
    return day === 0;
}

const handleShouldDisableTime = (time: Date, view: string) => {
    if (view === 'hours') {
        const hour = time.getHours();
        return hour < 8 || hour > 18;
    }

    if(view === 'minutes') {
        const hour = time.getHours();
        const minute = time.getMinutes();
        if(hour === 18) return minute > 0;
    }

    return false;
}

export {
    validationFileInitial,
    regexText,
    regexTime,
    MAX_FILE_SIZE,
    DAYS,
    validateIsWorkingDay,
    validateIsWorkingHours,
    validateIsDateInPast,
    defaultInterviewDateTime,
    handleShouldDisableDate,
    handleShouldDisableTime,
}
